import jsKit from './jsKit';

export const initFlashMessages = () => {
  document.querySelectorAll('[data-js-flash-messages]').forEach((element) => {
    try {
      jsKit.jsonNotificationsPanel(JSON.parse(element.dataset.jsFlashMessages));
    } catch (error) {
      console.error('Nie udało się odczytać komunikatów flash.', error);
    }
  });
};
